import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class EstensaWaitingService {

    private waiting = new BehaviorSubject(false);

    get isWaiting$() {
        return this.waiting.asObservable();
    }

    get isWaiting() {
        return this.waiting.value;
    }

    set isWaiting(value: boolean) {
        if (value != this.waiting.value) {
            this.waiting.next(value);
        }
    }
}
